/* jshint esnext: true */
import { $window, APP_NAME } from '../utils/environment';
import ProductAbstract from './ProductAbstract';

const MODULE_NAME = 'ProductOther';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};


export default class extends ProductAbstract{
    constructor(options) {
        super(options);

    }

    init() {

        this.scene.add(this.basePoint);

        if(window.innerWidth > 1024) {
            this.tableWidth = window.innerWidth / 3;
            // this.tableHeight = window.innerHeight / 15;
            this.tableHeight = window.innerWidth / 60;
        }else {
            this.tableWidth = window.innerWidth / 2;
            // this.tableHeight = window.innerHeight / 20;
            this.tableHeight = window.innerWidth / 25;
        }

        if(window.innerWidth > 1024) {
            this.basePoint.position.set(- window.innerWidth / 9.5,0,window.innerHeight / 2.5);
        }else {
            this.basePoint.position.set(window.innerHeight / 4,0,window.innerHeight / 4);
        }
        this.boxGeometry = new THREE.BoxGeometry(this.tableWidth, this.tableHeight, this.tableWidth/2);
        this.footGeometry = new THREE.BoxGeometry(2, this.tableHeight * 3, 2);
        this.whiteMaterial = new THREE.MeshLambertMaterial({color: 0xffffff, shading: THREE.FlatShading, side: THREE.DoubleSide});

        this.tableBase = new THREE.Mesh(this.boxGeometry, this.whiteMaterial);
        this.tableBase.rotation.set(0,0,0);
        this.tableBase.position.set(0,window.innerHeight * 2, 0);
        this.tableBase.castShadow = true;

        this.table = new THREE.Object3D();
        this.table.position.set(0,this.tableHeight * 1.5,0);

        this.table.add(this.tableBase);

        for (var i = 0; i <= 3; i++) {
            let foot = new THREE.Mesh(this.footGeometry, this.whiteMaterial);
            foot.castShadow = true;
            switch (i) {
                case 0:
                    foot.position.set(this.tableWidth/2 -1,window.innerHeight * 2,this.tableWidth/4 -1);
                    break;
                case 1:
                    foot.position.set(-this.tableWidth/2 +1,window.innerHeight * 2,this.tableWidth/4 -1);
                    break;
                case 2:
                    foot.position.set(-this.tableWidth/2 +1,window.innerHeight * 2,-this.tableWidth/4 +1);
                    break;
                case 3:
                    foot.position.set(this.tableWidth/2 -1,window.innerHeight * 2,-this.tableWidth/4 +1);
                    break;
                default:
                    foot.position.set(this.tableWidth/2,window.innerHeight * 2,this.tableWidth/4);
            }

            this.table.add(foot);

        }

        this.basePoint.add(this.table);

        this.timeout = setTimeout(()=> {
            this.show();
        },1000);

        this.animate();

    }

    /**
     * Show 3d object (animation)
     * @return {[type]} [description]
     */
    show() {

        TweenMax.to(this.tableBase.position,0.8,{
            y: (this.tableHeight * 2) - 3,
            ease: Power2.EaseOut,
            delay: 0.5
        });

        for (var i = this.table.children.length - 1; i >= 1; i--) {

            TweenMax.to(this.table.children[i].position,0.8,{
                y: 0,
                ease: Power2.EaseOut,
                delay: i * 0.08
            });
        }
    }


    //Request animation frame
    animate(){
        this.raf = requestAnimationFrame(()=>this.animate());

    }

    /**
     * hide 3d object (animation)
     * @return {[type]} [description]
     */
    hide() {
        clearTimeout(this.timeout);

        if(window.isVisible){
            TweenMax.to(this.tableBase.position,0.8,{
                y: window.innerHeight,
                ease: Power2.EaseIn
            });

            for (var i = 1; i < this.table.children.length; i++) {
                TweenMax.to(this.table.children[i].position,0.8,{
                    y: window.innerHeight,
                    ease: Power2.EaseIn,
                    delay: 0.1 + i * 0.08
                });
            }

            setTimeout(()=> {
                this.remove();
            },800);
        }else {
            this.remove();
        }
    }

    remove() {
        cancelAnimationFrame(this.raf);
        this.tableBase = null;
        this.table = null;
        for (var i = this.basePoint.children.length - 1; i >= 0; i--) {
            this.basePoint.remove(this.basePoint.children[i]);
        }
        this.scene.remove(this.basePoint);
    }

    destroy() {
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
